import gql from 'graphql-tag';
export const Empty_pending_seat = gql`
  mutation emptyPendingSeat($trip_id: ID!, $seat_number: ID!) {
    emptyPendingSeat(trip_id: $trip_id, seat_number: $seat_number) {
      success
      message
    }
  }
`;
